"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(field, startIndex, endIndex) {
  if (startIndex <= endIndex) {
    for (var i = startIndex; i < endIndex; i++) {
      field.swapFields(i, i + 1);
    }
  } else {
    for (var _i = startIndex; _i > endIndex; _i--) {
      field.swapFields(_i, _i - 1);
    }
  }
};